import { SearchableField } from '@purposely/common/src/insights'
import { JsonParam, useQueryParam } from 'use-query-params'

export interface SearchQuery {
  fieldKey: string
  value: string
  type: 'includes' | 'excludes'
}

export const useGlobalSearchQueries = () => {
  return useQueryParam<SearchQuery[] | undefined>('searchQueries', JsonParam)
}

const AD_SEARCH_QUERY_FIELD_KEYS = new Set<string>([
  SearchableField.Name,
  SearchableField.PrimaryText,
  SearchableField.CampaignName,
  SearchableField.CampaignId,
  SearchableField.AdId,
  SearchableField.AdLabel,
  SearchableField.AdSetId,
  SearchableField.AdSetName,
  SearchableField.Tag,
  SearchableField.HookText,
  SearchableField.Headline,
  SearchableField.DominantColor,
])

export const useAdSearchQueries = () => {
  const [searchQueries] = useGlobalSearchQueries()

  return searchQueries?.filter((sq) =>
    AD_SEARCH_QUERY_FIELD_KEYS.has(sq.fieldKey)
  )
}

const INSIGHT_SEARCH_QUERY_FIELD_KEYS = new Set<string>(
  Array.from(AD_SEARCH_QUERY_FIELD_KEYS)
    .filter(field => field !== SearchableField.AdLabel)
    .concat([SearchableField.LabelName])
);

export const useInsightSearchQueries = () => {
  const [searchQueries] = useGlobalSearchQueries()

  return searchQueries?.filter((sq) =>
    INSIGHT_SEARCH_QUERY_FIELD_KEYS.has(sq.fieldKey)
  )
}
